import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { renderClasses } from './QuestionSteps.styles';
import get from "lodash/get";
import classNames from "classnames";
import { isMobile } from "conversional-theme";
import { JourneysSelectors, useAppSelector } from 'conversional-journey';
var QuestionStepBreadcrumbItem = function (_a) {
    var _b, _c;
    var styles = _a.styles, width = _a.width, activeStep = _a.activeStep, changeStep = _a.changeStep, index = _a.index, step = _a.step;
    return _jsxs("div", { style: { width: width }, onClick: activeStep > index ? function () { return changeStep(index); } : undefined, className: classNames((_b = {},
            _b[styles.step] = true,
            _b[styles.activeBackground] = activeStep > index - 1,
            _b[styles.activeStep] = activeStep === index,
            _b[styles.clickableStep] = activeStep > index,
            _b)), children: [_jsxs("span", { children: [index + 1, ". "] }), _jsx("span", { className: classNames((_c = {},
                    _c[styles.stepTitle] = true,
                    _c[styles.activeStepTitle] = activeStep === index,
                    _c)), children: step.title })] }, index);
};
var QuestionSteps = function (_a) {
    var _b = _a.multistep, multistep = _b === void 0 ? {} : _b, activeStep = _a.activeStep, changeStep = _a.changeStep;
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    var styles = renderClasses(theme, {
        stepBg: multistep.stepBackgroundColor,
        activeStepBg: multistep.activeStepBackgroundColor,
        breadcrumbSpacing: 30
    });
    var steps = get(multistep, 'steps', []);
    return (_jsx("div", { className: styles.stepsContainer, children: (steps || []).map(function (step, index) {
            return _jsx(QuestionStepBreadcrumbItem, { width: !isMobile() ? "".concat(100 / steps.length, "%") : "auto !important", styles: styles, step: step, index: index, changeStep: changeStep, activeStep: activeStep }, "".concat(step.id, ".").concat(index));
        }) }));
};
export default QuestionSteps;
